import { transport } from 'config/transport';

export function callApiGenerateInvoice(congDoanId, classId, month, studentIds) {
    return transport.post(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu`, {}, { params: { month, studentIds } });
}
